// @flow
import type {SagaIterator} from 'redux-saga';
import {pushDataLayer} from '@optimaxdev/analytics/mobile';

import type {SimpleProductType} from 'constants/flow/flowTypesProduct';
import type {ActionType} from 'constants/flow/flowTypes';

import {productToEECProduct} from 'libs/EEC/convertData/productToEECProduct';
import {call, select} from 'redux-saga/effects';
import {getCategory} from 'selectors/category/category';

export type SimpleProductClickType = SimpleProductType & {index: number};

/**
 * This event is supposed to send the item on which a user clicked.
 *
 * @param {ActionType<{product: SimpleProductType}>} action - Product click action.
 */
export function* onProductClick(
    action: ActionType<void, {product: SimpleProductClickType}>,
): SagaIterator {
    if (action.meta) {
        const {product} = action.meta;
        const {title} = yield select(getCategory);
        const options = {
            category: title,
            index: product.index + 1,
        };
        const products = yield call(productToEECProduct, [product], options, {
            list: window.location.pathname,
        });
        yield call(pushDataLayer, {
            event: 'productClick',
            ecommerce: {
                click: {
                    actionField: {list: window.location.pathname},
                    products,
                },
            },
        });
    }
}
